<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <product-list
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"

            />
        </template>

         <add-button @click="create"></add-button>

        <product-create v-if="creating"
                        :open="creating"
                        v-on:itemCreated="onItemCreated"
                        v-on:close="creating=false"
        />

        <product-update v-if="updating"
                        :open="updating"
                        :item="itemToEdit"
                        v-on:itemUpdated="onItemUpdated"
                        v-on:close="updating=false"
        />

        <product-show v-if="showing"
                           :open="showing"
                           :item="itemToShow"
                           v-on:close="showing=false"
         />

        <product-delete v-if="deleting"
                         :open="deleting"
                         :item="itemToDelete"
                         v-on:itemDeleted="onItemDeleted"
                         v-on:close="deleting=false"
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>

    import ProductCreate from "../ProductCreate";
    import ProductUpdate from "../ProductUpdate";
    import ProductDelete from "../ProductDelete";
    import ProductShow from "../ProductShow";
    import ProductList from "../ProductListCustom";

     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"

    export default {
        name: "ProductCrud",
        components: {
            CrudLayout, AddButton, Snackbar,
            ProductCreate,
            ProductUpdate,
            ProductDelete,
            ProductShow,
            ProductList
        },
        data() {
            return {
                title: 'delivery.product.title',
                subtitle: 'delivery.product.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }

    }
</script>


